import { render, staticRenderFns } from "./dockBuyer.vue?vue&type=template&id=a962e008&scoped=true"
import script from "./dockBuyer.vue?vue&type=script&lang=js"
export * from "./dockBuyer.vue?vue&type=script&lang=js"
import style0 from "./dockBuyer.vue?vue&type=style&index=0&id=a962e008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a962e008",
  null
  
)

export default component.exports